import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M5.576 8.576a.6.6 0 0 1 .848 0L12 14.15l5.576-5.575a.6.6 0 0 1 .848.848l-6 6a.6.6 0 0 1-.848 0l-6-6a.6.6 0 0 1 0-.848Z"
      clip-rule="evenodd"
    />
  </svg>
`;
